import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useBlackBNF = () => useQuery({ queryKey: [`black-bnf`], queryFn: async () => {
    const callback = await API.get(`/black-bnf`)
    return callback?.data
}, staleTime: 1000 * 60 * 30, gcTime: 1000 * 60 * 60 * 24})

export default useBlackBNF